const faqs = [
    {
        id:1,
        question: "What is your educational background in Computer Science?",
        answer: "I am a Dec 2023 graduate from University of Houston majoring in Computer Science and minoring in Mathematics."
    },
    {
        id:2,
        question: "What programming languages are you proficient in?",
        answer: "I am very comfortable with C++ since that was the language of choice for most of my classes. However, I have experience working in Python, Javascript, HTML, CSS, MySql, and Java."
    },
    {
        id:3,
        question: "Do you have experience with web development?",
        answer: "Yes. I have actually worked on couple of web projects including the ones for my university courses and my personal projects. I learned HTML, CSS, Javascript, Bootstrap, React, and Django while learning web development."
    },
    {
        id: 4,
        question: "What are your career goals in computer science?",
        answer: "I want to learn as much as I can before taking any initiative on my own. I want to make some sort of meaningful impace using my skill set. Assuming a leadership role in the long run would be where I lean towards."
    },
    {
        id: 5,
        question: "How can I reach you?",
        answer: "You can reach me via email or send me a message on LinkedIn. I am active most of the time so reaching me should be no issue. You can find the links to my email and LinkedIn on this websites Contact section."
    }
];

export default faqs;